export const GET_CONFIG = 'GET_CONFIG';

export const GET_CONFIGS = 'GET_CONFIGS';

export const ADD_CONFIGS = 'ADD_CONFIGS';

export const UPDATE_CONFIGS = 'UPDATE_CONFIGS';

export const DELETE_CONFIGS = 'DELETE_CONFIGS';